/**
 * Created by Pawan on 6/5/2017.
 */

export default class StringUtil {
  static getFileExtension(str) {
    const FILE_NAME_DELIMITER = '.';

    let fileExtension = '';
    let fileNameParts = str.split(FILE_NAME_DELIMITER);
    if (fileNameParts && fileNameParts.length > 0) {
      fileExtension = fileNameParts[fileNameParts.length - 1];
    }
    return fileExtension;
  }

  static appendSuffixInFileName(fileName, suffix) {
    const index = fileName.lastIndexOf('.');
    if (index <= 0) return fileName + suffix;
    return fileName.substring(0, index) + suffix + fileName.substring(index);
  }

  static getFileName(str) {
    if (!str) return str;
    const index = str.lastIndexOf('/');
    if (index > -1) return str.substring(str.lastIndexOf('/') + 1);
    return str;
  }

  static removeLeadingTrailingQuotes(str) {
    const newStr = str.replace(/(^")|("$)/g, '');
    return newStr;
  }

  /**
   * @param fileName{string}
   * @param extension{string}
   * @return {string}
   */
  static replaceExtension(fileName, extension) {
    const oldExt = StringUtil.getFileExtension(fileName);
    if (oldExt) {
      fileName = fileName.replace(oldExt, extension);
    }
    return fileName;
  }

  /**
   * return true is a valid string.
   * @param str
   * @returns {boolean}
   */
  static isNotEmpty(str) {
    return !StringUtil.isEmpty(str);
  }

  /**
   * returns true is not a valid string.
   * @param str
   * @returns {boolean}
   */
  static isEmpty(str) {
    return StringUtil.isNull(str) || str === '' || str.replace(/\s/g, '').length <= 0;
  }

  static isNull(str) {
    return !str || str == null;
  }

  static parseTextForAtMentions(text, users = []) {
    const State = {
      INITIAL: 0,
      PROCESSING_NAME_OR_EMAIL: 1,
      IN_AT_MENTION_BETWEEN_NAMES: 2,
      IN_AT_MENTION_LAST_NAME: 3,
      PROCESSING_EMAIL: 4
    };

    let name = '';
    let names = [];
    let state = State.INITIAL;

    for (let i = 0; i <= text.length; i++) {
      switch (state) {
        case State.INITIAL:
          if (text[i] === '@') {
            state = State.PROCESSING_NAME_OR_EMAIL;
          }
          break;
        case State.PROCESSING_NAME_OR_EMAIL:
          name += text[i];
          if (/\s/.test(text[i])) {
            const tmpName = name.substring(0, name.length - 1);
            if (users.find((u) => u.label === tmpName)) {
              state = State.INITIAL;
              names.push(tmpName);
              name = '';
            } else {
              state = State.IN_AT_MENTION_BETWEEN_NAMES;
            }
          } else if (text[i] === '@') {
            state = State.PROCESSING_EMAIL;
          }
          break;
        case State.IN_AT_MENTION_BETWEEN_NAMES:
          name += text[i];
          if (text[i] !== ' ') {
            state = State.IN_AT_MENTION_LAST_NAME;
          }
          break;
        case State.IN_AT_MENTION_LAST_NAME:
          if (/\W/.test(text[i])) {
            state = State.INITIAL;
            names.push(name);
            name = '';
          } else {
            name += text[i];
          }
          break;
        case State.PROCESSING_EMAIL:
          if (/\W/.test(text[i]) && text[i] !== '.') {
            state = State.INITIAL;
            names.push(name);
            name = '';
          } else {
            name += text[i];
          }
          break;
      }
    }

    return names;
  }

  /**
   * Compares two strings. Case-insensitive.
   */
  static equals(s1: string = '', s2: string = '') {
    return s1.trim().toLowerCase() === s2.trim().toLowerCase();
  }

  /**
   * Checks if text contains pattern. Case-insensitive.
   */
  static contains(text: string = '', pattern: string = '') {
    return (
      String(text)
        .trim()
        .toLowerCase()
        .indexOf(
          String(pattern)
            .trim()
            .toLowerCase()
        ) > -1
    );
  }

  static indexOfIgnoreCase(text: string, pattern: string) {
    return String(text)
      .toLowerCase()
      .indexOf(pattern.toLowerCase());
  }

  static search(text: string, pattern: string): SearchResult[] {
    if (!pattern || !StringUtil.contains(text, pattern)) {
      return [{ text, isMatch: false }];
    }

    const result = [];
    let i = 0;
    while (i < text.length) {
      const s = text.substring(i);
      const index = StringUtil.indexOfIgnoreCase(s, pattern);
      if (index > -1) {
        const nonMatch = s.substring(0, index);
        result.push({ text: nonMatch, isMatch: false });
        const match = s.substring(index, index + pattern.length);
        result.push({ text: match, isMatch: true });
        i += index + pattern.length;
      } else {
        const nonMatch = text.substring(i);
        result.push({ text: nonMatch, isMatch: false });
        break;
      }
    }
    return result;
  }

  static SIZES = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  static prettyBytes(x) {
    let l = 0,
      n = parseInt(x, 10) || 0;
    while (n >= 1024 && ++l) n = n / 1024;
    return n.toFixed(n >= 10 || l < 1 ? 0 : 1) + ' ' + this.SIZES[l];
  }

  static updateDeltaPercent(length, deltaLength) {
    if (length > 0 && deltaLength > 0) {
      var percent = (deltaLength * 100) / length;
      if (percent <= 0) return '0.001%';
      percent = percent.toFixed(2);
      var prettyBytes = StringUtil.prettyBytes(deltaLength);
      return prettyBytes + ' (' + percent + '%)';
    }
    return null;
  }

  /**
   * Pluralizes `str` with `suffix` if `arr` is of size zero or greater than one.
   */
  static plural(str: string, arr: any[], suffix: string = 's') {
    return arr.length === 1 ? str : str.endsWith(suffix) ? str : `${str}${suffix}`;
  }

  static toFirstUpper(str: string): string {
    return str.charAt(0).toUpperCase() + (str.length > 1 ? str.substring(1) : '');
  }

  static toCamelCase(str: string, delimiter: string): string {
    const array: Array<string> = str.split(delimiter);
    if (array && array.length > 0) {
      for (var i: number = 0; i < array.length; i++) {
        var item: string = array[i];
        if (item.length > 0) {
          array[i] = item.charAt(0).toUpperCase() + (item.length > 1 ? item.substring(1) : '');
        }
      }
      return array.join(delimiter);
    }
    return str;
  }

  static createSortFn(sortByAttribute: string) {
    return function sort(a: Object, b: Object) {
      const valueA = (a[sortByAttribute] || '').toLowerCase();
      const valueB = (b[sortByAttribute] || '').toLowerCase();
      if (valueA < valueB) {
        return -1;
      }
      if (valueA > valueB) {
        return 1;
      }
      return 0;
    };
  }

  static containsInArray(patterns: Array<string>, valueString: string) {
    const element = patterns.find((a) => StringUtil.contains(valueString, a));
    if (element) return true;
    else return false;
  }
  static isURL(name: string) {
    let regexp = new RegExp('^(http|https)://', 'i');
    if (regexp.test(name)) {
      return true;
    } else {
      return false;
    }
  }
}

export type SearchResult = {
  text: string,
  isMatch: boolean
};

export const swapArrayLocs = function(arr, index1, index2) {
  const temp = arr[index1];
  arr[index1] = arr[index2];
  arr[index2] = temp;
};
